import gql from 'graphql-tag';

const MUTATION_DELETE_USER = gql`
  mutation deleteUser($userId: ID!) {
    deleteUser(userId: $userId) {
      isSuccess
      message
    }
  }
`;

export default MUTATION_DELETE_USER;
